// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.propertyList {
  width: 1200px;
  margin: 0px auto;
  margin-bottom: 60px;
  display: flex;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
  height: 150px;
}
.propertyList ul {
  display: flex;
  height: 100%;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Huoban/index.less"],"names":[],"mappings":"AAAA;EAAc,aAAA;EAAc,gBAAA;EAAiB,mBAAA;EAAqB,aAAA;EAAgB,sBAAA;EAC9E,mBAAA;EAAoB,gBAAA;EAAmB,aAAA;AAQ3C;AATA;EAEM,aAAA;EAAe,YAAA;EAAc,mBAAA;AAYnC","sourcesContent":[".propertyList{width:1200px; margin:0px auto; margin-bottom: 60px; display: flex;  border: 1px solid #ddd; \n    border-radius:10px; overflow: hidden;  height: 150px;\n   ul{display: flex; height: 100%; align-items: center;}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
